export default {
    steps: {
      of: 'Etapa {current} de {total}',
      title: {
        1: 'Identifique a sua bracelete',
        2: 'Verificar o montante reembolsável',
        3: 'Introduza os seus dados bancários'
      }
    },
    refunds: 'Devoluções',
    actions: {
      accept: 'Aceitar'
    },
    main: {
      start: 'Iniciar o processo de regresso',
      refund_unavailable: 'O processo de devolução não está actualmente disponível.'
    },
    tagId: {
      label: 'ID da pulseria',
      validate: 'Validar a pulseira',
      tag_placement:
        'Pode encontrar o seu chip ID na frente ou atrás.',
      id_description: 'É uma sequência de 14 ou 15 números e letras.'
    },
    balance: {
      current: 'Balanço actual',
      comission: 'Taxas de gestão',
      total: 'Reembolso total',
      refund: 'Proceder ao reembolso',
      message: {
        not_enough_balance: 'Reembolso não disponível. A taxa de manuseamento excede o saldo actual.',
        balance_too_large: 'As devoluções acima de {amount} não são automatizadas.'
      }
    },
    bank_data: {
      document: 'Documento',
      name: 'Nome',
      surname: 'Primeiro apelido',
      second_surname: 'Segundo apelido',
      phone: 'Número de telefone',
      email: 'Correio electrónico',
      document_type: 'Tipo',
      confirm_refund: 'Confirmar o reembolso de  {amount}',
      hint: {
        phone: 'Inclua o seu código de país: +34 666 666 666'
      },
      document_types: {
        NATIONAL_ID_CARD: 'Cartão de identidade',
        PASSPORT: 'Passaporte',
        ARG_TAX_DOCUMENT: 'CUIL/CUIT',
        MEXICAN_RFC: 'RFC Mexicano',
        UYU_CI: 'CI Uruguay'
      },
      account_types: {
        IBAN: 'IBAN',
        CBU: 'CBU',
        CLABE: 'CLABE',
        UYU_ACCOUNT: 'UYU Cuenta'
      }
    },
    result: {
      back_to_main: 'Voltar à página principal'
    },
    error: {
      not_found: {
        title: 'Uau, não há nada aqui',
        subheading: 'Aceder a este pedido através da ligação fornecida.',
        tag: 'Este chip não foi utilizado neste evento'
      },
      500: `Ocorreu um erro no servidor, estamos a trabalhar nisso!`,
      0:
        'Oops, o servidor parece não estar disponível, volte a verificar mais tarde!',
      bad_request: {
        any: {
          required: 'Obrigatório',
          empty: 'Obrigatório'
        },
        string: {
          base: 'Obrigatório',
          hex: 'Identificação do chip inválido. Deve ter 14 ou 15 dígitos.',
          invalid_tag: 'Identificação do chip inválido. Verificar os dígitos introduzidos.',
          min: `Não tem o comprimento mínimo`
        },
        iban: {
          invalid: 'IBAN inválido'
        },
        cbu: {
          invalid: 'CBU inválido'
        },
        clabe: {
          invalid: 'CLABE inválido'
        },
        uyu_account: {
          invalid: 'Comprimento incorreto, deve ter 14 dígitos.'
        },
        email: {
          invalid: 'Endereço de e-mail inválido'
        },
        phone: {
          invalid: 'Número de telefone inválido. Inclua o seu código de país: +34 666 666 666'
        },
        cuil_cuit: {
          invalid: 'CUIL/CUIT inválido'
        },
        mexican_rfc: {
          invalid: 'RFC inválido'
        },
      }
    },
    message: {
      close: 'Mensagem de fecho'
    },
    decimal_separator: ',',
    warnings: {
      important: 'Importante: ',
      complete_name: 'O nome completo e o apelido do beneficiário devem ser preenchidos, caso contrário o reembolso não poderá ser efectuado correctamente.'
    }
  }
  